import React from 'react';
import { isCard } from './helpers';

export const CardsColumnContainer = ({ children, className = '' }) => {
  const items = React.Children.toArray(children).filter(Boolean);
  return (
    <div className={className}>
      {items.map((child, i) => {
        if (isCard(child)) {
          const props = child.props || {};
          const merged = {
            ...props,
            colClasses: '',
          };
          return (
            <div className="mb-3" key={i}>
              {React.cloneElement(child, merged)}
            </div>
          );
        }
        return (
          <div className="mb-3" key={i}>
            {child}
          </div>
        );
      })}
    </div>
  );
};

// Marker statico per il riconoscimento senza import incrociato (evita il ciclo
// CardsColumnContainer ↔ helpers): `helpers.isCardsColumnContainer` lo legge.
CardsColumnContainer.isCardsColumnContainer = true;
